// ----------------------------
// Virtual Market
// ----------------------------

// ------------------------------------
// Imports
// ------------------------------------
import { put, call, takeLatest } from 'redux-saga/effects'
import {
  GET_TOKEN, getTokenSucceeded, getTokenFailed,
  PUT_TOKEN, putTokenSucceeded, putTokenFailed,
  FINISH_SESSION, finishSessionSucceeded, finishSessionFailed,
  SEND_EMAIL, sendEmailSucceeded, sendEmailFailed,
  UPDATE_USER_DATA, updateUserDataSucceeded, updateUserDataFailed,
  SET_LANGUAGE, setLanguageFailed, setLanguageSuccess, SET_LANGUAGE_FAILED,
  GET_LANGUAGE, getLanguageFailed, getLanguageSuccess,
  SET_LAST_PATH, setLastPathFailed, setLastPathSuccess, END_PROCESS
} from '../modules/module_settings.js'
import { API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'
import { doCallback, setAppLanguage } from 'utilities/general-utils'
import { flushSession, updateSettingsStorage } from 'utilities/session-utils'
import protocols from 'common-protocols'

// ------------------------------------
// Services
// ------------------------------------
import { getToken, putToken, finishSession, sendPDF, endSession,
  sendUserData, requestSetLanguage, requestGetLanguage, 
  requestSetLastPath } from 'services/settings-api'

// ------------------------------------
// Sagas
// ------------------------------------

/* Sagas - Workers */
function* getTokenRequested(action) {
  const { response, error } = yield call(getToken);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = getTokenSucceeded(response.data);
  } else {
    if (error.request.response === protocols.TICKETS_EXPIRE) {
      message = protocols.TICKETS_EXPIRE;
    }
    actionToDo = getTokenFailed(error);
  }

  yield put(actionToDo);

  if (action.callback){
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* putTokenRequested(action) {
  const { response , error } = yield call(putToken, action.token);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = putTokenSucceeded();
  } else {
    actionToDo = putTokenFailed(error);
  }

  yield put(actionToDo);

  if (action.callback) {
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* finishSessionRequested(action) {
  const { response , error } = yield call(finishSession, action.token);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = finishSessionSucceeded();
  } else {
    actionToDo = finishSessionFailed(error);
  }

  yield put(actionToDo);

  if (action.callback) {
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* endSessionRequested(action) {
  console.log(action)
  const { response , error } = yield call(endSession, action.token);

  console.log(response)
  console.log(error)
  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = finishSessionSucceeded();
  } else {
    actionToDo = finishSessionFailed(error);
  }

  yield put(actionToDo);

  if (action.callback) {
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* sendEmailRequested(action) {
  const { response, error } = yield call(sendPDF, action.token, action.term);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if (response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = sendEmailSucceeded();
  } else {
    actionToDo = sendEmailFailed(error);
  }

  yield put(actionToDo);

  if (action.callback) {
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* updateUserDataRequested(action) {
  const { response, error } = yield call(sendUserData, action.token, action.term);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if (response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = updateUserDataSucceeded();
  } else {
    actionToDo = updateUserDataFailed(error);
  }
  
  yield put(actionToDo);
  
  if (action.callback) {
    doCallback(action.callback, message, response ? response.data : error && error.response && error.response.data ? error.response.data : null);
  }
  
}

function* setLanguageWorker({language, token}){
  const {error, response} = yield call(requestSetLanguage, {language, token});
  
  yield put(setLanguageSuccess(language));
  let locale;
    switch(response.data.idioma){
      case "Esp":
        locale = 'es';
        break;
      case "Eng":
        locale = "en";
        break;
      default:
        locale = 'es';
    }
  setAppLanguage(locale);
}

function* getLanguageWorker(){
  const {error, response} = yield call(requestGetLanguage);
  if(!!response.data && !!response.data.idioma){
    let language;
    switch(response.data.idioma){
      case "Esp":
        language = 'es';
        break;
      case "Eng":
        language = "en";
        break;
      default:
        language = 'es';
    }
    yield put(getLanguageSuccess(language));
    setAppLanguage(language);
  } else {
    yield put(getLanguageFailed({error}));
  }
}

function* setLastPathWorker({token, path}){
  try {
    const result = yield call(requestSetLastPath, {
      token,
      path
    });
    if(!!result.response.data){
      updateSettingsStorage(path, 'lastPath');
      yield put(setLastPathSuccess(path))
    } else {
      yield put(setLastPathFailed())
      flushSession();
    }
  } catch(e){
    yield put(setLastPathFailed())
    flushSession();
  }
}

/* Sagas - Watchers/Listeners */
export function* watchGetToken() {
  yield takeLatest(GET_TOKEN, getTokenRequested);
}

export function* watchPutToken() {
  yield takeLatest(PUT_TOKEN, putTokenRequested);
}

export function* watchFinishSession() {
  yield takeLatest(FINISH_SESSION, finishSessionRequested);
}

export function* watchSendEmail() {
  yield takeLatest(SEND_EMAIL, sendEmailRequested);
}

export function* watchUpdateUserData() {
  yield takeLatest(UPDATE_USER_DATA, updateUserDataRequested);
}

export function* watchSetLanguage(){
  yield takeLatest(SET_LANGUAGE, setLanguageWorker);
}

export function* watchGetLanguage(){
  yield takeLatest(GET_LANGUAGE, getLanguageWorker);
}

export function* watchSetLastPath(){
  yield takeLatest(SET_LAST_PATH, setLastPathWorker);
}

export function* watchEndSession(){
  yield takeLatest(END_PROCESS, endSessionRequested);
}

// ------------------------------------
// Exports Functions
// ------------------------------------

export const settingsSagas = [
    watchGetToken,
    watchPutToken,
    watchFinishSession,
    watchSendEmail,
    watchUpdateUserData,
    watchSetLanguage,
    watchGetLanguage,
    watchSetLastPath,
    watchEndSession
];



// WEBPACK FOOTER //
// ./src/store/sagas/sagas_settings.js